import React, { ChangeEvent, FocusEvent, MouseEvent } from 'react';
import classNames from 'classnames';
import {Input} from "@eika/input";
import InputWrapper from './InputWrapper';
import { generateId } from '../util/Functions';
import { InputContent, StringObject } from '../../types';

export interface TextfieldProps {
    content: InputContent;
    formAction: any;
    change: (e: ChangeEvent<HTMLInputElement>) => void;
    blur: (e: FocusEvent<HTMLInputElement>) => void;
    click: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>, k: string) => void;
};

const Textfield: React.FC<TextfieldProps> = (props): React.ReactElement => {
    const { content, blur, change, click, formAction: {formState, register} } = props;
    const id = content.id || generateId('textfield');
    const error = formState.errors[content.name];

    const attr: StringObject = [
        'required',
        'defaultValue',
        'placeholder',
        'maxLength',
        'minLength',
    ].reduce( (pin: StringObject, key: string) => {
        // @ts-ignore
        if ( content[key] !== undefined ){ pin[key] = content[key]; }
        return pin;
    }, {
        id, 
        name: content.name,
        type: content.type,
        autoCapitalize: 'off',
        autoComplete: 'off',
        autoCorrect: 'off',
        spellCheck: 'false',
        'aria-invalid': error?.message ? `${!!error?.message}` : '',
        'aria-controls': error?.message ? `${id}-error` : '',
    });

    Object.keys(attr).forEach( (key: string) => {
        if ( attr[key] === '' ) { delete(attr[key]); }
    });

    return <InputWrapper {...content} error={error?.message} id={id} addStyle={content.fieldButton ? 'has-button-in-the-end' : ''}>
        <>
            <Input {...attr} {...register(attr.name)} onChange={(e: ChangeEvent<HTMLInputElement>) =>{change(e);}} onBlur={(e: FocusEvent<HTMLInputElement>) => {blur(e);}} />
            { !!content.fieldButton && <a 
                href="#" 
                role="button" 
                onClick={(e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => { click(e, (content.fieldButton?.action || '')); }} 
                className={classNames('field-button', content.fieldButton.type.toLowerCase(), `-mode-${content.fieldButton.mode}`)}
                aria-label={content.fieldButton.textPin ? (content.fieldButton.textPin[content.fieldButton.mode as string] || '' ) : (content.fieldButton.text || '')}
            /> }
        </>
    </InputWrapper>
};

export default Textfield;

